import { api } from './client'

export const authApi = {
  login: (email, password) =>
    api.post('/auth/login', { email, password }),

  signup: (email, password, full_name) =>
    api.post('/auth/signup', { email, password, full_name }),

  googleAuth: (credential) =>
    api.post('/auth/google', { credential }),

  me: (token) => api.get('/auth/me', token),

  updateProfile: (data, token) => api.patch('/auth/me', data, token),

  completeOnboarding: (data, token) =>
    api.post('/auth/onboarding', data, token),

  // Under-18 restrict path. Sends ONLY the DOB so the server can compute
  // age authoritatively; the server sets age_restricted and discards the
  // DOB (never persisted). Returns the updated UserOut.
  ageRestrict: (date_of_birth, token) =>
    api.post('/auth/age-restrict', { date_of_birth }, token),

  // Redeem an invite / referral code for the signed-in user. Server
  // normalizes case + whitespace. Resolves to
  // { success, grants_status, referral_code } or throws on 4xx.
  applyCode: (code, token) =>
    api.post('/auth/apply-code', { code }, token),

  // The signed-in user's own personal referral code (or null).
  myReferralCode: (token) =>
    api.get('/auth/my-referral-code', token),

  forgotPassword: (email) =>
    api.post('/auth/forgot-password', { email }),

  resetPassword: (access_token, new_password) =>
    api.post('/auth/reset-password', { access_token, new_password }),

  // Permanently delete the signed-in user's account and all data
  // (App Store Guideline 5.1.1(v) — must be reachable in-app).
  deleteAccount: (token) =>
    api.delete('/auth/me', token),
}
